import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { instagramIntegrationsQuery } from "modules/settings/lib/instagram/instagramIntegrationsQuery"

export function useDeleteInstagramIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await axios.delete(`/integrations/instagram/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: instagramIntegrationsQuery().queryKey })
    },
  })
}
